
// export const uploadPath = 'http://prod.turasistan.com/'
// export const socketPath = 'http://prod.turasistan.com:9000'
// export const reportPath = 'http://reporttest.turasistan.com/'

export const uploadPath = 'https://prod.turasistan.com/'
export const socketPath = 'https://prod.turasistan.com:9000'
export const reportPath = 'https://reporttest.turasistan.com/'
export let languageId = 2
// export const languageId = window.localStorage.getItem('languageId') ? 2 : parseInt(window.localStorage.getItem('languageId'))
// export const reportPath = 'http://localhost:52734/'

// Versiyon kontrolü için kullanılan değer
export const APP_VERSION = '1.18'

let _redirectPath = '' // rezervasyon tamamlandıktan sonra redirect edilecek sayfa
if (window.location.origin.toLowerCase().indexOf('semersaheurope') > -1) {
	_redirectPath = 'http://semersaheurope.com/'
} else if (window.location.origin.toLowerCase().indexOf('ditibvoyages') > -1) {
	_redirectPath = 'http://ditibvoyages.com/'
} else {
	_redirectPath = 'http://localhost:8085/'
}

export const redirectPath = _redirectPath

let _reservationUrl = '' // tur listesindeki rezervasyon linki
if (window.location.origin.toLowerCase().indexOf('semersaheurope') > -1) {
	_reservationUrl = '/tourReservation/sales/create'
} else if (window.location.origin.toLowerCase().indexOf('ditibvoyages') > -1) {
	_reservationUrl = '/tourReservation/sales/create2'
} else {
	_reservationUrl = '/tourReservation/sales/create'
}
export const reservationUrl = _reservationUrl

let _defaultTitle = '' // page default title
if (window.location.origin.toLowerCase().indexOf('semersaheurope') > -1) {
	_defaultTitle = 'Semerşah Europe'
} else if (window.location.origin.toLowerCase().indexOf('ditibvoyages') > -1) {
	_defaultTitle = 'DITIB'
} else {
	_defaultTitle = 'Local Title'
}
export const defaultTitle = _defaultTitle

let _defaultFaviconPath = '' // page default favicon path
if (window.location.origin.toLowerCase().indexOf('semersaheurope') > -1) {
	_defaultFaviconPath = '/static/Favicons/semersah_europe.ico'
} else if (window.location.origin.toLowerCase().indexOf('ditibvoyages') > -1) {
	_defaultFaviconPath = '/static/Favicons/ditib.ico'
} else {
	_defaultFaviconPath = '/static/Favicons/favicon.ico'
}
export const defaultFaviconPath = _defaultFaviconPath



// WEBPACK FOOTER //
// ./src/config/index.js